/** блок адаптации **/
import './common/adapterFromOldStyle'
/** блок адаптации **/

import {ItemSlider} from './helpUkraine/item-slider';
import './helpUkraine/style.css';
import { Accordeon } from './header/accordeon'

let accordeon = new Accordeon()
accordeon.init()


document.addEventListener('click', event => {
    const link = event.target.closest('a[href*="#"]');
    if (!link || !link.hash) return;

    const target = document.querySelector(link.hash);
    if (!target) return;

    event.preventDefault();
    window.scrollTo({
        top: target.getBoundingClientRect().top + window.scrollY - 170,
        behavior: 'smooth'
    });
});

ItemSlider.init();